import { ImageOff } from "lucide-react";
import { useState } from "react";
import { cn } from "../lib/cn";

/** Изображение из API: WebP-варианты по ширине (320/640/1280) + размытое превью до загрузки. */
export type RemoteImageData = { urls: Record<string, string>; blurData?: string | null; width?: number | null; height?: number | null };

export function RemoteImage({
  image, alt, sizes = "(max-width: 640px) 50vw, 320px", className, priority, fallbackClassName,
}: { image: RemoteImageData | null | undefined; alt: string; sizes?: string; className?: string; priority?: boolean; fallbackClassName?: string }) {
  const [loaded, setLoaded] = useState(false);
  if (!image) {
    return (
      <div className={cn("grid place-items-center bg-surface-2 text-subtle", className, fallbackClassName)} aria-label={alt} role="img">
        <ImageOff className="size-6" strokeWidth={1.5} />
      </div>
    );
  }
  const widths = Object.keys(image.urls).map(Number).sort((a, b) => a - b);
  const srcSet = widths.map((w) => `${image.urls[String(w)]} ${w}w`).join(", ");
  const src = image.urls[String(widths[Math.min(1, widths.length - 1)])];
  return (
    <img
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      width={image.width ?? undefined}
      height={image.height ?? undefined}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      onLoad={() => setLoaded(true)}
      style={!loaded && image.blurData ? { backgroundImage: `url(${image.blurData})`, backgroundSize: "cover" } : undefined}
      className={cn("object-cover transition-opacity", className)}
    />
  );
}
